export default __webpack_public_path__ + "static/media/detalle_transaccion.921acb1c.svg";